<template>
<!-- Sections -->
<section id="mod-home" 
    :class="['pt-page','pt-page-1',
    meanList[0].clicked ? 'pt-page-current' : '',
    meanList[0].leave ? 'pt-page-moveToTop pt-page-current':'',
    meanList[0].enter ? 'pt-page-scaleUp':'']">
    <div class="mod-bg-video covervid-wrapper loop" style="overflow: hidden;">
      <span class="close"><span></span><span></span></span>
      <video class="covervid-video" id="loopVideo"  loop="'true'" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); height: auto; width: 1320px;" @canplay="canplay" muted><source src="../media/160329_Rimowa_Topas_Loop_v2_2000.mp4" type="video/mp4"><!-- <source src="../media/160329_Rimowa_Topas_Loop_v2_2000.webm" type="video/webm"> --></video>
      <div class="controls">
        <span class="btnPlay"><i class="icon-Pause"></i></span><span class="volumen"><i class="icon-Sound_on"></i></span><span class="progressBar"><span class="duration"><span class="currentTime"></span></span><span class="time"></span></span>
      </div>
    </div>
    <div :class="['mod-bg-video','covervid-wrapper','full',currentBoolean.isFullPlay ? 'anim' :'animout']" 
    style="overflow: hidden;">
      <span class="close" @click="closeFullPlay"><span></span><span></span></span>
      <video class="covervid-video" id="fullVideo" @timeupdate="progressBarVal"
      style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); height: auto; width: 1860px;"><source src="../media/160329_Rimowa_Topas_Loop_v2_2000.mp4" type="video/mp4"><!-- <source src="../media/160304_Rimowa_RET_V11_with_CGI_Topas_v10_3500.webm" type="video/webm"> --></video>
      <div :class="['controls',currentBoolean.isFullPlay ? 'active' : '']">
        <span class="btnPlay" @click="toggleFullPlay">
          <i :class="[currentBoolean.toggleFullPlay ? 'icon-Play' : 'icon-Pause']"></i>
        </span>
        <span class="volumen" @click="toggleFullPlayMuted">
          <i :class="[currentBoolean.toggleFullPlayMuted ? 'icon-Sound_off' : 'icon-Sound_on']"></i>
        </span>
        <span class="progressBar" @click="getProgressBar" id="fullBar">
          <span class="duration" :style="progressWidth"><span class="currentTime"></span></span><span class="time" v-cloak>{{ pageText.time }}</span>
        </span>
      </div>
    </div>
    <!-- Webpartzones --><!-- Webparts -->
    <div class="mod-section-home content-container">
      <div class="claim anim">
        <span class="logo"></span>
        <p>
          保持饥饿，保持愚蠢
        </p>
      </div>
      <h2><span class="first"><span class="active"><span>欢迎来到吴伟的主页</span></span></span><span class="second"><span class="active"><span class="anim">里面有你所需要的。</span></span></span></h2>
      <div class="video-btn-wrapper">
        <div class="video-btn" @click="canFullPlay">
        </div>
      </div>
      <p class="infoText anim">
        我是一个追求自由的人。财务自由，精神自由。虽然我现在只是一个伪全栈开发工程师，但是我相信未来肯定会更好。
      </p>
    </div>
</section>
</template>

<script>
export default {
  props:['pageBoolean','meanList'],
  data(){
    return{
      progressWidth:{
        width:0
      },
      pageText:{
        time:0,
      },
      currentBoolean:{
        isFullPlay:false,
        toggleFullPlay:false,
        toggleFullPlayMuted:false
      }
    }
  },
  methods:{
    canplay(){
      var video=document.getElementById('loopVideo');
      //console.log('可以开始播放了');
      this.pageBoolean.showLoad=false;
      video.style.width=window.innerWidth+'px';
      video.play();
    },
    toggleFullPlay(){
      var fullVideo=document.getElementById('fullVideo');
      this.currentBoolean.toggleFullPlay=!this.currentBoolean.toggleFullPlay;
      if(this.currentBoolean.toggleFullPlay){
        this.progressBarVal();
        fullVideo.pause();
      }else{
        fullVideo.play();
      }
    },
    toggleFullPlayMuted(){
      var fullVideo=document.getElementById('fullVideo');
      this.currentBoolean.toggleFullPlayMuted=!this.currentBoolean.toggleFullPlayMuted;
      fullVideo.muted=this.currentBoolean.toggleFullPlayMuted;
    },
    canFullPlay(){
      var video=document.getElementById('loopVideo'),fullVideo=document.getElementById('fullVideo');
      this.currentBoolean.isFullPlay=true;
      //console.log('大屏播放');
      video.pause();
      fullVideo.play();
    },
    closeFullPlay(){
      var video=document.getElementById('loopVideo'),fullVideo=document.getElementById('fullVideo');
      this.currentBoolean.isFullPlay=false;
      this.currentBoolean.toggleFullPlay=false;
      //console.log('关闭播放');
      fullVideo.pause();
      video.play();
    },
    progressBarVal(){
      var fullVideo=document.getElementById('fullVideo');
      //console.log(fullVideo.currentTime.toFixed(0) +'秒');
      this.pageText.time=this.showTime(fullVideo.currentTime.toFixed(0));
      this.progressWidth.width=(fullVideo.currentTime / fullVideo.duration*100).toFixed(5)+'%';
      //console.log((fullVideo.currentTime / fullVideo.duration*100).toFixed(5)+'%');
    },
    getProgressBar(e){
      var fullVideo=document.getElementById('fullVideo'),fullBar=document.getElementById('fullBar'),
      precent=(e.clientX/fullBar.clientWidth).toFixed(5),currentTime=0;
      currentTime=fullVideo.duration*precent;
      //console.log(fullVideo.duration);//总时间
      //console.log(e.clientX);//选择的长度
      //console.log(fullBar.clientWidth);//总长度
      fullVideo.currentTime=currentTime;
      //console.log(currentTime);
    },
    showTime(time){
      var timeStr="";
      if(time < 10){
        timeStr="0:0"+time;
      }else if(time < 60){
        timeStr="0:"+time;
      }else{
        if(time % 60 < 10){
          timeStr=Math.floor(time/60)+":0"+time % 60;
        }else{
          timeStr=Math.floor(time/60)+":"+time % 60;
        }
      }
      return timeStr;
    }
  }
}
</script>

<style>
.home{
  width: 100%;
  height: 100%;
}
[v-cloak] {
  display: none;
}
</style>



// WEBPACK FOOTER //
// Home.vue?d3e330e2